/**
 * ConventionSwitcher
 */

import React, { memo, useContext } from 'react'

import { CurrentConventionContext } from 'currentConventionContext'
import { useCurrentUser } from 'currentUserContext'

const ConventionSwitcher = () => {
	const current_user = useCurrentUser()
	const is_god_user = Boolean(current_user?.is_god)

	const { convention, conventions, series, series_list, setSeriesId, setConventionId, loading } =
		useContext(CurrentConventionContext)

	const series_options = Array.isArray(series_list) ? series_list : []
	const convention_options = Array.isArray(conventions) ? conventions : []

	const selected_series_id = series?.id || convention?.convention_series?.id || ''
	const selected_convention_id = convention?.id || ''

	const allow_dev_switching = process.env.ENV === 'development'

	const show_series_select = Boolean(allow_dev_switching && series_options.length > 1)
	const show_convention_select = Boolean(convention_options.length > 1)

	if (!is_god_user) return null
	if (!show_series_select && !show_convention_select) return null

	return (
		<div className="flex flex-col items-end gap-1">
			{show_series_select && (
				<div className="flex items-center gap-2">
					<span className="text-slate-500 dark:text-slate-400 text-sm">Series:</span>
					<select
						className="text-sm h-8 border border-slate-200 dark:border-slate-700 rounded px-2 bg-white dark:bg-slate-900 text-slate-700 dark:text-slate-200"
						disabled={Boolean(loading) || series_options.length === 0}
						value={selected_series_id}
						onChange={(e) => setSeriesId(e.target.value)}
					>
						{series_options.length === 0 ? (
							<option value="">(no series)</option>
						) : (
							series_options.map((s) => (
								<option key={s.id} value={s.id}>
									{s.name}
								</option>
							))
						)}
					</select>
				</div>
			)}

			{show_convention_select && (
				<div className="flex items-center gap-2">
					<span className="text-slate-500 dark:text-slate-400 text-sm">Convention:</span>
					<select
						className="text-sm h-8 border border-slate-200 dark:border-slate-700 rounded px-2 bg-white dark:bg-slate-900 text-slate-700 dark:text-slate-200"
						disabled={Boolean(loading) || convention_options.length === 0}
						value={selected_convention_id}
						onChange={(e) => setConventionId(e.target.value)}
					>
						{convention_options.length === 0 ? (
							<option value="">(no conventions)</option>
						) : (
							convention_options.map((c) => (
								<option key={c.id} value={c.id}>
									{c.name}
								</option>
							))
						)}
					</select>
				</div>
			)}
		</div>
	)
}

ConventionSwitcher.propTypes = {}

export default memo(ConventionSwitcher)
